import React from 'react'
import { Input } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  setImage: PropTypes.func
}

const defaultProps = {
  setImage: () => {alert('set image function triggered')}
}

const CustomerRefundPaymentImageUpload = ({ setImage }) => {

  const onChange = (event) => {
    const input  = event.target.files[0]
    const reader = new FileReader()
    setImage(input)

    reader.readAsDataURL(input)
    reader.onload = () => {
      var dataURL = reader.result
      var output  = document.getElementById('output')
      output.src  = dataURL
    }
  }

  return (
    <>
      <Input
        type='file'
        accept='image/*'
        onChange={ (event) => onChange(event) }
      />
      <img
        id='output'
        className='mt-3'
        width='300'
        alt=''
      />
    </>
  )
}

CustomerRefundPaymentImageUpload.propTypes    = propTypes
CustomerRefundPaymentImageUpload.defaultProps = defaultProps

export default CustomerRefundPaymentImageUpload
